import React from 'react';
import * as classes from './mediaShareFooter.module.css';

export default function MediaShareFooter({ slug, title }) {
  let facebook_link =
    'https://www.facebook.com/sharer.php?u=https://www.feedingindia.org/blog/' +
    slug +
    '&t=' +
    title;
  let linkedin_link =
    'http://www.linkedin.com/shareArticle?mini=true&url=https://www.feedingindia.org/blog/' +
    slug +
    '&title=' +
    title;
  let twitter_link =
    'http://twitter.com/intent/tweet?text=' +
    title +
    '&url=https://www.feedingindia.org/blog/' +
    slug;

  return (
    <div className={classes.empty_div}>
      <div className={classes.share_logos}>
        <a href={facebook_link}>
          <img
            src="https://b.zmtcdn.com/data/web_assets/2ff51440dca8fb57e5f8d31ee2f490561585892722.jpeg"
            alt="facebook"
          />
        </a>
        <a href={linkedin_link}>
          <img
            src="https://b.zmtcdn.com/data/web_assets/7711302d96ed0463d08e69419cca52cf1585892834.png"
            alt="linkedin"
          />
        </a>
        <a href={twitter_link}>
          <img
            src="https://b.zmtcdn.com/data/web_assets/2610e909ef01dd478e8cd4c7ea7ba7061585892807.png"
            alt="twitter"
          />
        </a>
      </div>
    </div>
  );
}
